define.alias("shared/utils/time-slot-utils", "settings/utils/time-slot-utils");